/**
 * created by li si yi
 * 内容安全中心路由
 */
import React, {Component} from 'react';
import ContentSecurityCenter from '../ContentSecurityCenter'
import Details from "../components/Details";
import SecurityPreview from "../components/security-preview/security-preview";

export const contentSecurityCenterRouter = [
    {
        path: "/view/contentSecurityCenter/ContentSecurityCenter",
        component: ContentSecurityCenter
    },
    {
        path: "/view/contentSecurityCenter/details",
        frame:'no-frame',
        component: SecurityPreview
    },
];